import { ColumnTable, Icon } from '@octano/global-ui';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const dictPrefix = 'financialPortal.currentAccount.tabs.paymentHistory.table';

const formatDate = (value: unknown) => {
  if (!value) {
    return '-';
  }
  const d = dayjs(value as string);
  return d.isValid() ? d.utc().format('DD/MM/YYYY') : '-';
};

export default function useColumns(): ColumnTable<any>[] {
  const { t } = useTranslation();

  const translateOrFallback = (path: string, value: unknown) => {
    if (value == null || value === '') {
      return '-';
    }
    return t(`${path}.${value}`, { defaultValue: String(value) });
  };

  return [
    {
      columnName: 'paymentDate',
      headerText: t(`${dictPrefix}.paymentDate`),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ value }) => formatDate(value),
    },
    {
      columnName: 'paymentType',
      headerText: t(`${dictPrefix}.paymentType`),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ value }) =>
        translateOrFallback('paymentHub.paymentsTable.types', value),
    },
    {
      columnName: 'paymentChannel',
      headerText: t(`${dictPrefix}.paymentChannel`),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      // La pasarela llega como `gatewayCode` ('webpay-plus', 'iceberg', …) o
      // como 'discount' en las devoluciones: se busca primero en el
      // diccionario de pasarelas y después en el de orígenes.
      cellFormat: ({ value }) => {
        if (value == null || value === '') {
          return '-';
        }
        return t(
          [
            `paymentHub.paymentsTable.gateways.${value}`,
            `paymentHub.paymentsTable.origins.${value}`,
          ],
          { defaultValue: String(value) },
        );
      },
    },
    {
      columnName: 'voucherId',
      headerText: t(`${dictPrefix}.voucherId`),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'transactionCode',
      headerText: t(`${dictPrefix}.transactionCode`),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'paidBy',
      headerText: t(`${dictPrefix}.paidBy`),
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      // HU-15671: link de descarga al comprobante adjunto del refund charge
      // (presente solo en filas tipo refund).
      columnName: 'attachmentUrl',
      headerText: t(`${dictPrefix}.attachment`),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ value }) => {
        if (!value || typeof value !== 'string') {
          return '-';
        }
        return (
          <a
            href={value}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary fw-600 d-inline-flex align-items-center"
            style={{ textDecoration: 'underline' }}
          >
            {t(`${dictPrefix}.downloadAttachment`)}
            <span className="ml-2">
              <Icon name="download" size="16px" color="primary" />
            </span>
          </a>
        );
      },
    },
  ];
}
